/* <soh-accordion data-single>: wraps <details> elements. data-single = only one open at a time. */
class SohAccordion extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-single')) return;
    this.addEventListener('toggle', (e) => { if (e.target.open) this.querySelectorAll('details[open]').forEach(d => d !== e.target && (d.open = false)); }, true);
  }
}
customElements.define('soh-accordion', SohAccordion);
